import { Component, Injector, Optional, Input } from '@angular/core';

import { FactuurregelService } from 'src/app/core/service/factuurregel.service';
import { Factuurregel } from 'src/app/core/dto/factuurregel';
import { Filter, FilterBuilder, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';
import { Factuur } from 'src/app/core/dto/factuur';
import { Projectregel } from 'src/app/core/dto/projectregel';

@Component({
    selector: 'c-i-j-borculo-factuurregel-collection',
    templateUrl: './factuurregel-collection.component.html'/*,
    styleUrls: ['./factuurregel-collection.component.css'] */
})
export class FactuurregelCollectionComponent extends PagedCollectionComponent<Factuurregel> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<Factuurregel>([
    { colDef: 'projectregel', prop: x => x.pakbonregel.projectregel.certificaatId, searchable: SearchableType.Number },
    { colDef: 'barcode', prop: x => x.pakbonregel.projectregel.instrument.nr_Barcode, searchable: SearchableType.Number },
    { colDef: 'soort', prop: x => x.pakbonregel.projectregel.instrument.soort, searchable: SearchableType.String },
    { colDef: 'type', prop: x => x.pakbonregel.projectregel.instrument.type, searchable: SearchableType.String },
    { colDef: 'omschrijving', prop: x => x.omschrijving, searchable: SearchableType.String },
    { colDef: 'aantal', prop: x => x.aantal},
    { colDef: 'prijs', prop: x => x.prijs},
    { colDef: 'regelprijs', prop: x => x.regelprijs },
    { colDef: 'korting', prop: x => x.korting },
    { colDef: 'prijsblock', prop: x => x.pakbonregel.projectregel.prijsBlock },
    { colDef: 'goedgekeurdOp', prop: x => x.factuur.goedgekeurdOp },
    
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: FactuurregelService, @Optional() protected filter: Filter<Factuurregel>, injector: Injector) {
        super('/factuurregel/factuurregel', injector, Factuurregel);

      this.initInput('factuur', this.filterBuilder.equal(x => x.factuur.id));
      this.initInput('projectregel', this.filterBuilder.equal(x => x.pakbonregel.projectregel.id));

      this.filter.onGetChipLabel(x => x.pakbonregel.projectregel.certificaatId, () => 'Projectregel');
      this.filter.onGetChipLabel(x => x.pakbonregel.projectregel.instrument.nr_Barcode, () => 'Barcode');
      this.filter.onGetChipLabel(x => x.pakbonregel.projectregel.instrument.soort, () => 'Soort');
      this.filter.onGetChipLabel(x => x.pakbonregel.projectregel.instrument.type, () => 'Type');
      this.filter.onGetChipLabel(x => x.omschrijving, () => 'Omschrijving');
      this.filter.onGetChipLabel(x => x.aantal, () => 'Aantal');
      this.filter.onGetChipLabel(x => x.prijs, () => 'Prijs');
      this.filter.onGetChipLabel(x => x.korting, () => 'Korting');
    }

	displayColumn(colDef: ColumnDefinition, ix: number) {
		// Hide columns that are already filtered on
		if(colDef.colDef == 'factuur' && this.factuur != null) { return false; }
    if(colDef.colDef == 'prijsblock') { return false; }
    if(colDef.colDef == 'goedgekeurdOp') { return false; }

		return super.displayColumn(colDef, ix);
	}

  private _factuur: Factuur;

	@Input() set factuur(val: Factuur) {
     this.handleInput('factuur', val.id);
     this._factuur = val;
  }

	@Input() set projectregel(val: Projectregel) {
     this.handleInput('projectregel', val.id);
  }

  canDelete() {
    if (this._factuur === undefined){
      return false;
    } else {
      if (this._factuur?.goedgekeurdOp !== null && this._factuur?.goedgekeurdOp !== undefined) {
        return false;
      } else {
        if (this._factuur?.isProForma) {
          return this.authScheme.canDelete('CIJBorculo.Logic.Factuurregel');       
        } else {
          return false;
        }
      }
    }
  }

}